
import { defineComponent, ref, reactive, toRefs, onMounted, watchEffect, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Charts, Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      option: {},
      data: [],
      columns: [],
      spinning: true,
      pagination: {
        showSizeChanger: true,
        showTotal: (total: any) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showQuickJumper: true
      }
    })
    const color = globalsets.getColor()
    pageData.columns = [
      {
        title: '日期/类型',
        dataIndex: 'time',
        key: 'time',
        width: '100px',
        fixed: 'left'
      },
      {
        title: '总股本',
        dataIndex: 'TotalShares',
        key: 'TotalShares',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '流通受限股份',
        dataIndex: 'RestrictedAShares',
        key: 'RestrictedAShares',
        width: '110px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '国有法人持股',
        dataIndex: 'SLegalPersonHolding',
        key: 'SLegalPersonHolding',
        width: '110px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '其他内资持股',
        dataIndex: 'OtherDCapitalHolding',
        key: 'OtherDCapitalHolding',
        width: '110px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '境内自然人持股',
        dataIndex: 'DNPersonHolding',
        key: 'DNPersonHolding',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '境外自然人持股',
        dataIndex: 'FNPersonHolding',
        key: 'FNPersonHolding',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '已流通股份',
        dataIndex: 'AlreadyShares',
        key: 'AlreadyShares',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '已上市流通A股',
        dataIndex: 'NonResiSharesJY',
        key: 'NonResiSharesJY',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '变动原因',
        dataIndex: 'MS',
        key: 'MS',
        width: '180px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      }
    ]
    watch(
      () => (props.pageSourceData || {}).EquityChangesData,
      () => {
        const data = (props.pageSourceData || {}).EquityChangesData || []
        const _data = JSON.parse(JSON.stringify(data))
        if ((_data || []).length) {
          _data.forEach((item: any, i: number) => {
            item.index = 'EquityChangesData' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
        }
        pageData.data = _data
        nextTick(() => {
          setcharts(_data)
          pageData.spinning = false
        })
      },
      { deep: true }
    )

    function setcharts(data: any) {
      let _data: any = data
      _data = _data.slice(0, 10)
      const legenddata = ['总股本(股)', '流通受限股份(股)', '已上市流通A股(股)']
      let splitLine = {
        lineStyle: {
          color: '#DBDFE6'
        }
      }
      const axisLine = {
        lineStyle: {
          color: '#7D7D7D'
        }
      }
      if (props.theme === 'dark') {
        splitLine = {
          lineStyle: {
            color: '#252A34'
          }
        }
      }
      let xAxis = _data.map((item: any) => window.moment(item.EndDate * 1000).format('YYYY-MM-DD'))
      xAxis = [...new Set(xAxis)]
      xAxis = xAxis.reverse()
      pageData.option = {
        color: color,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params: any) {
            var htmlStr = ''
            htmlStr += '<div class="optiontooltip"><p style="color:rgba(0,0,0,0.45);">' + params[0].name + '</p>'
            for (var i = 0; i < params.length; i++) {
              // 前面的原点和他的颜色
              const value = globalsets.getNumber(params[i].value)
              // if (i === 1) {
              //   value = value + '%'s
              // }
              htmlStr +=
                '<span style="width: 8px;height: 8px;display:inline-block;margn-right: 4px;background-color:' +
                params[i].color +
                '"></span><span style="color:#000;margin-left: 6px;">' +
                params[i].seriesName +
                ':</span>' +
                '<span style="color:#000;float:right;margin-left: 12px">' +
                value +
                '</span><br/>'
            }
            htmlStr += '</div>'
            return htmlStr
          }
        },
        legend: {
          bottom: '15px',
          itemGap: 20,
          data: legenddata,
          textStyle: {
            color: '#7d7d7d'
          }
        },
        grid: {
          left: 10,
          right: 28,
          top: 20,
          bottom: 50,
          containLabel: true
        },
        toolbox: {
          show: false,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#7D7D7D'
              }
            },
            axisTick: {
              show: false
            },
            data: xAxis
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            splitLine: splitLine,
            axisLine: axisLine,
            splitNumber: 4
          }
        ],
        series: [
          {
            name: legenddata[0],
            type: 'bar',
            barGap: 0,
            barWidth: 20,
            // emphasis: {
            //   focus: 'series'
            // },
            data: _data.map((item: any) => item.TotalShares).reverse()
          },
          {
            name: legenddata[1],
            type: 'bar',
            barWidth: 20,
            // emphasis: {
            //   focus: 'series'
            // },
            data: _data.map((item: any) => item.RestrictedAShares).reverse()
          },
          {
            name: legenddata[2],
            type: 'bar',
            barWidth: 20,
            // emphasis: {
            //   focus: 'series'
            // },
            data: _data.map((item: any) => item.NonResiSharesJY).reverse()
          }
        ]
      }
    }
    return {
      ...toRefs(pageData)
    }
  }
})
